export default "__VITE_ASSET__5edd69ef__"